import React from "react";
import styles from "../side.module.scss";
import { GA_LABEL_ENUMS, triggerGAEvent } from "../../../../../constant/google-analytics/GAEvents";
import { sideBarData } from "../../../../../constant/sideMenuOptions";
import ProfileMenu from "../sideBarProfile/sideBarProfile";
import ProfileDetails from "../profile/profile";
import SideMenuDropDown from "../../../../reusableComponent/sideMenuDropDown/sideMenuDropDown";
import ChatHistoryPanel from "../../../../reusableComponent/sideBar/history/ChatHistoryPanel";
import { logBookConversion } from "../../../../../experiments";

interface NewSideBarContentProps {
  isMobile: boolean;
  isDesktopSidebarExpand: boolean;
  toggleSidebar: () => void;
  setIsOpenMobileSidebar: (isOpen: boolean) => void;
  setIsAdminChat: (isAdmin: boolean) => void;
  setCurrentHistoryId: (id: string) => void;
  handleNav: () => void;
  handleMobNav: () => void;
  userInfo: any;
  firstScreen: string;
  screen: string;
  handleSelect: (value: string) => void;
}

const NewSideBarContent: React.FC<NewSideBarContentProps> = ({
  isMobile,
  isDesktopSidebarExpand,
  toggleSidebar,
  setIsOpenMobileSidebar,
  setIsAdminChat,
  setCurrentHistoryId,
  handleNav,
  handleMobNav,
  userInfo,
  firstScreen,
  screen,
  handleSelect,
}) => {
  const isAdmin = userInfo?.role === 1 || userInfo?.role === 3 || userInfo?.role === 4;

  const startNewChat = () => {
    triggerGAEvent(GA_LABEL_ENUMS.new_trip_click);
    setIsAdminChat(false);
    if (isMobile) handleMobNav();
    else handleNav();
  };

  const startPublicChat = () => {
    triggerGAEvent(GA_LABEL_ENUMS.new_trip_public_click);
    setCurrentHistoryId("");
    setIsAdminChat(true);
    if (isMobile) handleMobNav();
    else handleNav();
  };

  if (isMobile) {
    return (
      <div className={styles.mobileDrawerCard}>
        <ChatHistoryPanel
          variant="mobileDrawer"
          onNewChat={startNewChat}
          showPublicChat={isAdmin}
          onPublicChat={startPublicChat}
          setIsOpenMobileSidebar={setIsOpenMobileSidebar}
        />
      </div>
    );
  }

  const isShopSelected = screen === "newBooking";
  const isTripsSelected = !isShopSelected && firstScreen === "myTrips";
  const isChatSelected =
    !isShopSelected &&
    !isTripsSelected &&
    (firstScreen === "newTrip" || firstScreen === "topDestination" || firstScreen === "");

  const selectedByScreen: Record<string, boolean> = {
    chat: isChatSelected,
    book: isShopSelected,
    myTrips: isTripsSelected,
  };

  const handleRailSelect = (screenName: string) => {
    if (screenName === "chat") {
      startNewChat();
    } else if (screenName === "book") {
      logBookConversion("sidebar");
      handleSelect("Shop travel");
    } else if (screenName === "myTrips") {
      handleSelect("My Trips");
    }
  };

  return (
    <div className={styles.subSideBar}>
      <div className={styles.railMenu}>
        <div className={styles.railTop}>
          <ProfileDetails
            mode="mascot"
            onClick={toggleSidebar}
            handleClick={() => {}}
            isLoggedIn={userInfo?.loggedIn}
            userName={userInfo?.name}
            isDesktopSidebarExpand={isDesktopSidebarExpand}
          />
        </div>
        <div className={styles.railNav}>
          {sideBarData.map((item, index) => (
            <SideMenuDropDown
              key={index}
              icon={item.icon}
              label={item.label}
              isSelected={!!selectedByScreen[item.screenName]}
              onSelect={() => handleRailSelect(item.screenName)}
            />
          ))}
        </div>
        {userInfo?.loggedIn && (
          <div className={styles.railFooter}>
            <ProfileMenu
              toggleSidebar={toggleSidebar}
              setIsOpenMobileSidebar={setIsOpenMobileSidebar as any}
              isDesktopSidebarExpand={isDesktopSidebarExpand}
              mode="avatar"
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default NewSideBarContent;
